module.exports = __webpack_public_path__ + "6101fec2a8cb8fb94721566e7519ae29.svg";